type Statuses = 'NOT_EXISTS' | 'READY' | 'DELETED' | 'PENDING' | 'UPLOADING'

export const TrainingStatus: Record<Statuses, string> = {
  NOT_EXISTS: 'NOT_EXISTS',
  PENDING: 'PENDING',
  READY: 'READY',
  DELETED: 'DELETED',
  UPLOADING: 'UPLOADING',
}
